module.exports = __webpack_public_path__ + "static/media/Leccion-12-10-La-Integridad-del-Discipulo.90d09ac0.pdf";